import React from 'react';
import { withStyles } from '@material-ui/core';

import TraceList from './TraceList';
import TraceDetail from './TraceDetail';

import axiosInstance, { API_URL } from '../common/Constants';

const styles = (theme) => ({});

class MyTrace extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      traceState: 'list',
      // traceDetailItem: null,
      courseId: null,
      stampId: null,
      isQueryParam: false,
      refresh: false,
      userInfo: null,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.stampId !== nextProps.stampId && nextProps.courseId !== '' && nextProps.stampId !== '') {
      return {
        courseId: nextProps.courseId,
        stampId: nextProps.stampId,
        traceState: 'detail',
        refresh: true,
      };
    } else if (prevState.courseId !== nextProps.courseId && nextProps.courseId !== '') {
      if (!prevState.courseId) {
        return { courseId: nextProps.courseId, traceState: 'detail' };
      }
    }

    if (prevState.userInfo !== nextProps.userInfo) {
      return { userInfo: nextProps.userInfo, refresh: true };
    }

    return null;
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.userInfo) {
      if (this.state.refresh) {
        this.setState({ refresh: false });
        this.getTraceList();
      }
    }

    if (prevProps.queryStr.courseId !== '' && prevState.traceState === 'detail' && this.state.traceState === 'detail') {
      document.body.style.overflowY = 'inherit';
      if (
        navigator.userAgent.match(/mobile/i) ||
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPod/i) ||
        navigator.userAgent.match(/iPad/i) ||
        navigator.userAgent.match(/^(safari|(?!chrome).)*$/gi)
      ) {
        document.body.style.overflow = 'inherit';
      }
    }
  }

  getTraceList() {
    // 이 부분은 언제 userInfo를 앞단에서 넘긴 시점이 애매하며,

    let buff = [];

    let res = { data: this.props.userInfo };

    if (res.data.stamp) {
      this.setState({ stamp: res.data.stamp });
    } else {
      this.setState({ stamp: [] });
    }
    if (res.data.course) {
      this.setState({ course: res.data.course });
    } else {
      this.setState({ course: [] });
    }

    axiosInstance.get(`${API_URL}/course/list`, {}).then((_res) => {
      buff = _res.data;
      if (res.data && res.data.course) {
        for (let i = 0; i < res.data.course.length; i++) {
          for (let j = 0; j < _res.data.length; j++) {
            if (res.data.course[i] === _res.data[j].id) {
              buff[j].isCompleted = true;
            }
          }
        }
      }

      this.setState({ traceList: buff });
    });
    //});
  }

  componentDidMount() {}

  handleState = (stateTitle, newVal) => {
    this.setState(() => ({
      [stateTitle]: newVal,
    }));
  };

  handleDetailToList = () => {
    this.props.handleDetailToList();
    this.setState({ traceState: 'list' });
    // console.log(this.props);
    // this.props.history.replace('/mypage');
  };

  render() {
    return (
      <div>
        {this.state.traceState === 'list' && <TraceList handleState={this.handleState.bind(this)} userInfo={this.props.userInfo} />}
        {this.state.traceState === 'detail' && (
          <TraceDetail
            handleState={this.handleState.bind(this)}
            handleDetailToList={this.handleDetailToList.bind(this)}
            userStampList={this.state.stamp}
            isQueryParam={this.props.isQueryParam}
            userInfo={this.props.userInfo}
            reviewId={this.props.reviewId}
            courseId={this.state.courseId}
            stampId={this.state.stampId}
            mode={this.props.mode}
            queryStr={this.props.queryStr}
          />
        )}
      </div>
    );
  }
}

export default withStyles(styles)(MyTrace);
